import { render, staticRenderFns } from "./ItemsOsList.vue?vue&type=template&id=f71326f8&scoped=true&"
import script from "./ItemsOsList.vue?vue&type=script&lang=js&"
export * from "./ItemsOsList.vue?vue&type=script&lang=js&"
import style0 from "./ItemsOsList.vue?vue&type=style&index=0&id=f71326f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71326f8",
  null
  
)

export default component.exports